export default __webpack_public_path__ + "static/media/LithiumSoftware.0cf70c67.webp";